// apps/widget/src/screens/prepare.screen.tsx
//
// "Get ready", between the questions and the camera: the four things that
// decide whether the photo is worth analysing, read before the camera opens
// rather than discovered from a disappointing result. A split screen like the
// welcome and consent screens, with the clinic's picture on the right.

import { useEffect } from 'react';
import { PrepareContent } from '../components/capture-tips';
import { preloadFaceMesh } from '../lib/facemesh';
import { SplitVisual } from '../components/split-visual';
import { useScan } from '../state';

export function PrepareScreen() {
  // Already started on the consent screen; this covers a flow that skips it.
  useEffect(() => preloadFaceMesh(), []);
  const { state, go } = useScan();
  return (
    <div className="gs-welcome gs-welcome--form">
      <div className="gs-welcome__copy">
        <PrepareContent onReady={() => go('capture')} />
      </div>
      <SplitVisual config={state.config} />
    </div>
  );
}
